import axios from "axios";
import { ActionType } from "../action-types";
import { AppThunk } from "./types";
import { http } from "../../utils/http";
import { ContactDto } from "../../dto/contact";

export const searchCustomersByCode =
  (customerCode: string): AppThunk<Promise<void>> =>
  async (dispatch, getState) => {
    const jwt = getState().token;
    if (!jwt) throw new Error("Missing JWT!");

    const trimmed = customerCode.trim();

    if (!trimmed) {
      dispatch({
        type: ActionType.SET_CUSTOMER_SEARCH_RESULTS,
        payload: { query: "", item: {} as ContactDto },
      });
      return;
    }

    dispatch({
      type: ActionType.SET_CUSTOMER_SEARCH_LOADING,
      payload: true,
    });

    try {
      const res = await http.get("/api/contacts", {
        params: { customerCode: trimmed },
      });

      const item: ContactDto = res.data;

      dispatch({
        type: ActionType.SET_CUSTOMER_SEARCH_RESULTS,
        payload: { query: trimmed, item },
      });
    } catch (error) {
      dispatch({
        type: ActionType.SET_CUSTOMER_SEARCH_RESULTS,
        payload: { query: trimmed, items: [] },
      });

      if (axios.isAxiosError(error)) {
        const status = error.response?.status ?? "NO_STATUS";
        const text =
          typeof error.response?.data === "string"
            ? error.response.data
            : JSON.stringify(error.response?.data ?? "");
        throw new Error(
          `GET /whatshelp-public/api/contacts failed REQUEST: ${status} ${text}`
        );
      }

      throw error;
    } finally {
      dispatch({
        type: ActionType.SET_CUSTOMER_SEARCH_LOADING,
        payload: false,
      });
    }
  };
